import { Box, Grid, IconButton, List, ListItem, ListItemText } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const GrapherResolutionData = ({
    graphSelectedMap,
    graphs,
    dataSource,
    valueTab,
    actualGraph,
    actualGraphResolution,
    mapGraphSelectedMapTab,
    onDeleteFilterApplied,
}) => {
    return (
        <>
            {Object.keys(graphSelectedMap).length > 0 && (
                <Grid container display={"flex"} justifyContent={"center"}>
                    <Grid item xs={6} lg={4} sx={{ maxHeight: 200, overflow: "auto" }}>
                        <h4> Gráficos Agregados</h4>
                        <ul
                            style={{
                                listStyleType: "disc",
                                paddingLeft: "1.5rem",
                                margin: 0,
                            }}
                        >
                            {Object.entries(graphSelectedMap).map(
                                ([key, el]) =>
                                    el.selected && (
                                        <li key={key}>
                                            <Box display="flex" alignItems="center" sx={{ py: 1 }}>
                                                <Box>
                                                    {graphs.find((g) => g.value === key)?.name}
                                                </Box>
                                            </Box>
                                        </li>
                                    )
                            )}
                        </ul>
                    </Grid>
                    <Grid item xs={6} lg={4} sx={{ maxHeight: 200, overflow: "auto" }}>
                        {dataSource === "static" && actualGraph !== "word_cloud" && (
                            <div>
                                <h4>
                                    {`Filtros Aplicados-${
                                        (
                                            graphs.find(
                                                (g) =>
                                                    g.value ===
                                                    (valueTab === 1
                                                        ? actualGraph
                                                        : actualGraphResolution)
                                            ) || {}
                                        ).name
                                    }`}
                                </h4>
                                <ul
                                    style={{
                                        listStyleType: "disc",
                                        paddingLeft: "1.5rem",
                                        margin: 0,
                                    }}
                                >
                                    {mapGraphSelectedMapTab[valueTab][
                                        valueTab === 1 ? actualGraph : actualGraphResolution
                                    ]?.filterInclude.map((obj, idx) => (
                                        <li key={idx}>
                                            <Box
                                                display="flex"
                                                textAlign="left"
                                                justifyContent="space-between"
                                                sx={{ py: 1 }}
                                            >
                                                <Box>
                                                    <div>
                                                        {obj.label} <strong> (Incluir) </strong>
                                                    </div>
                                                </Box>
                                                {/* {valueTab === 1 && (
                                                    <IconButton
                                                        onClick={() =>
                                                            onDeleteFilterApplied(obj, "include")
                                                        }
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                )} */}
                                            </Box>
                                        </li>
                                    ))}
                                    {mapGraphSelectedMapTab[valueTab][
                                        valueTab === 1 ? actualGraph : actualGraphResolution
                                    ]?.filterExclude.map((obj, idx) => (
                                        <li key={idx}>
                                            <Box
                                                display="flex"
                                                textAlign="left"
                                                justifyContent="space-between"
                                                sx={{ py: 1 }}
                                            >
                                                <Box>
                                                    <div>
                                                        {obj.label} <strong> (Excluir) </strong>
                                                    </div>
                                                </Box>
                                                {/* {valueTab === 1 && (
                                                    <IconButton
                                                        onClick={() =>
                                                            onDeleteFilterApplied(obj, "exclude")
                                                        }
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                )} */}
                                            </Box>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default GrapherResolutionData;
